var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4 9.71 7.194 9.808a1 1 0 0 0 1.612 0L20 9.71a1 1 0 0 0-.038-1.231l-2.785-3.342a1 1 0 0 0-.604-.346l-4.409-.735a1 1 0 0 0-.328 0l-4.409.735a1 1 0 0 0-.603.346L4.039 8.478A1 1 0 0 0 4 9.709Zm-1.612 1.182 7.193 9.809a3 3 0 0 0 4.838 0l7.194-9.809a3 3 0 0 0-.115-3.695l-2.785-3.342a3 3 0 0 0-1.811-1.038l-4.409-.735a3 3 0 0 0-.986 0l-4.408.735a3 3 0 0 0-1.812 1.038L2.502 7.197a3 3 0 0 0-.114 3.695Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.72 10H20a1 1 0 1 0 0-2h-2.656l.826-2.755a1 1 0 1 0-1.915-.574l-.602 2.006-2.36-3.54a1.555 1.555 0 0 0-2.587 0l-2.359 3.54-.602-2.006a1 1 0 1 0-1.915.574L6.656 8H4a1 1 0 0 0 0 2h3.28l3.471 10.416a1.316 1.316 0 0 0 2.498 0L16.72 10Zm-2.588-2L12 4.803 9.869 8h4.263Zm-4.745 2L12 17.838 14.613 10H9.387Z",
    fill: "#777E91"
  })));
};
export default SvgLine;